import Swiper, { Navigation, Pagination } from "swiper";
import { initIntersectionObserver } from "@plugins";

Swiper.use([Navigation, Pagination]);

const sidebarStock = document.querySelector(".js-sidebar-stock-slider-init");

if (sidebarStock) {
    initIntersectionObserver(sidebarStock, initSidebarStockSlider);
}

function initSidebarStockSlider(section) {
    new Swiper(section, {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        grabCursor: true,
        pagination: {
            el: ".js-sidebar-stock-slider-controls > .swiper-pagination",
            clickable: true,
        },
        navigation: {
            prevEl: ".js-sidebar-stock-slider-controls .swiper-button-prev",
            nextEl: ".js-sidebar-stock-slider-controls .swiper-button-next",
        },
    });
}
